import apiHandler from "../core/apiHandler";

const invalidationTypeApi = apiHandler('invalidation-types');
export default invalidationTypeApi;
